import React from "react";
import { AppBar, Box, Dialog, Grid, IconButton, Slide, Button, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography } from "@mui/material";
import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";
import { ReactComponent as GreenArrow } from "../Assets/svg/greenArrow.svg";
import { ReactComponent as MobileIcon } from "../Assets/svg/MobileIcon.svg";
import { ReactComponent as PhoneIcon } from "../Assets/svg/PhoneIcon.svg";
import { ReactComponent as MailIcon } from "../Assets/svg/MailIcon.svg";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function PropertyContactModal(props) {

    const { propInfo } = props

    return (
        <Dialog className="dialog-box"
            fullScreen
            open={props.ContactModal}
            onClose={props.handleContactModalClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                <Toolbar>
                    {/* <IconButton>
                    <SettingIcon />
                </IconButton> */}
                    <Typography sx={{ mx: 'auto', fontSize: '12px' }} variant="h6" component="div">

                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={props.handleContactModalClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>

                </Toolbar>
            </AppBar>
            <Box sx={{ p: 2 }}>
                <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2, pb: 2 }}>
                    <Box className="header-dark-blue">
                        مشخصات مالک
                    </Box>
                    <Box sx={{ p: 2 }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Grid container>
                                <Grid item xs={3}>کد ملک</Grid>
                                <Grid item xs={9}>{propInfo.Row}</Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={3}>نام مالک</Grid>
                                <Grid item xs={9}>{propInfo.FullName}</Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={3}>آدرس ملک</Grid>
                                <Grid item xs={9}>{propInfo.PhysicalAddress}</Grid>
                            </Grid>
                        </Box>
                    </Box>
                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px', flexDirection: 'column', px: 1 }}>
                        {propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <a href={`tel:${propInfo.LandLord && propInfo?.LandLord && propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value}`}>
                                <MobileIcon />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: "1" }}>
                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "center" }}>{propInfo.LandLord && propInfo?.LandLord && propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value}</Box>
                                    <GreenArrow />
                                </Box>
                            </a>
                        </Button>}
                        {propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <a href={`sms:${propInfo.LandLord && propInfo?.LandLord && propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value}`}>
                                <MailIcon />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: "1" }}>
                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "center" }}>{propInfo.LandLord && propInfo?.LandLord && propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value}</Box>
                                    <GreenArrow />
                                </Box>
                            </a>
                        </Button>}
                        {propInfo.LandLord && propInfo?.LandLord.Telephones.Tel[0]?.value && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <a href={`tel:${propInfo.LandLord && propInfo?.LandLord && propInfo.LandLord && propInfo?.LandLord.Telephones.Tel[0]?.value}`}>
                                <PhoneIcon />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flex: "1" }}>
                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px', textAlign: "center" }}>{propInfo.LandLord && propInfo?.LandLord && propInfo.LandLord && propInfo?.LandLord.Telephones.Tel[0]?.value}</Box>
                                    <GreenArrow />
                                </Box>
                            </a>
                        </Button>}
                    </Grid>
                </Box>
            </Box>
        </Dialog>
    );
}

export default PropertyContactModal;